import { Stack } from "@chakra-ui/react";
import { EventDataDto, PublicContextDto } from "../../../autogen/bff-api";
import { AboutSection } from "./AboutSection";
import { ClassificationSection } from "./ClassificationSection";
import { ContractSection } from "./ContractSection";
import { CriteriaSection } from "./CriteriaSection";
import { DocumentsSection } from "./DocumentsSection";
import { PublicationsSection } from "./PublicationsSection";

interface Props {
  eventData: EventDataDto;
  publicContext: PublicContextDto;
}

export const RequestTab = ({ eventData, publicContext }: Props) => (
  <Stack spacing="5">
    <AboutSection eventData={eventData} />
    <ClassificationSection publicContext={publicContext} />
    <CriteriaSection eventData={eventData} />
    <ContractSection eventData={eventData} publicContext={publicContext} />
    <DocumentsSection documents={eventData.documents ?? []} />
    <PublicationsSection publications={publicContext.publications ?? []} />
  </Stack>
);
